var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.53317 10.6667H7.13317C8.4665 10.6667 8.99984 10.1334 8.99984 8.80004V7.20004C8.99984 5.86671 8.4665 5.33337 7.13317 5.33337H5.53317C4.19984 5.33337 3.6665 5.86671 3.6665 7.20004V8.80004C3.6665 10.1334 4.19984 10.6667 5.53317 10.6667Z",
    stroke: "#1E293B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3335 13.3333H4.66683C2.00016 13.3333 1.3335 12.6666 1.3335 9.99996V5.99996C1.3335 3.33329 2.00016 2.66663 4.66683 2.66663H11.3335C14.0002 2.66663 14.6668 3.33329 14.6668 5.99996V9.99996C14.6668 12.6666 14.0002 13.3333 11.3335 13.3333Z",
    stroke: "#1E293B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackup);
export default __webpack_public_path__ + "static/media/Backup.ad054b6c6589854509b3acf13c6107ab.svg";
export { ForwardRef as ReactComponent };